export const signIn = "/auth/signin";
export const signUp = "/auth/signup";
export const authProfile = "/auth/profile";
export const authPassword = "/auth/password";
export const home = "/home";
export const profile = "/profile";
export const orders = "/orders";
export const ordersDetails = "/orders/details";
export const portfolio = "/portfolio";
export const blogDetail = "/blogDetail";
export const blogList = "/blogList";
export const paymentSuccess = "/payment-success";
export const paymentFailed = "/payment-failed";
export const paymentProcessing = "/payment-processing";
export const orderSummary = "/order-summary";
export const variantList = "/product-variant";
export const buyNow = "/buynow";
export const paymentSummary = "/pay-summary";
export const renewalDetails = "/renewal/details";
export const renewal = "/renewal";
export const attribute = "/attribute";
export const compare = "/compare";
